import {observable} from "mobx";
import {CountryViewModel} from "../../country/models/country-view-model";
import {BookmakerViewModel} from "../../bookmaker/models/bookmaker-view-model";
import {TvNetworkDomainModel} from "./tv-network-domain-model";
import {TvNetworkImageRequestParams} from "./tv-network.image-request-params";
import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";

export class TvNetworkViewModel extends EntityViewModel {
  country: CountryViewModel;
  bookmaker: BookmakerViewModel;
  iconUrl: String;
  @observable website: String;

  constructor(domain: TvNetworkDomainModel, country: CountryViewModel, bookmaker: BookmakerViewModel, iconUrl: String) {
    super(domain);

    this.country = country;
    this.bookmaker = bookmaker;
    this.iconUrl = iconUrl;
  }

  get logo(): TvNetworkImageRequestParams {
    return new TvNetworkImageRequestParams(this.id);
  }
}
